import request from '@/utils/request'

const url = '/home/supplier/'
const api = {
  Query (data) {
    return request({
      url: url + 'getSupplierList',
      method: 'post',
      data
    })
  },
  saveSupplier (data) {
    return request({
      url: url + 'saveSupplier',
      method: 'post',
      data
    })
  },
  delSupplier (data) {
    return request({
      url: url + 'delSupplier',
      method: 'post',
      data
    })
  },
  changeproject (data) {
    return request({
      url: url + 'changeproject',
      method: 'post',
      data
    })
  },
  checkRepeat (data) {
    return request({
      url: url + 'checkRepeat',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/supplier.js